import BasePage from "pages/base_page"
import ProfileNewslettersIndex from "containers/ProfileNewslettersIndex"
import React from "react"
import { createRoot } from "react-dom/client"
import Region from "models/profiles/newsletters/region"
import User from "models/profiles/newsletters/user"

class ProfileNewslettersPage extends BasePage {
  constructor(options) {
    super()

    const domContainer = document.getElementById("profile-newsletters-index")

    const container = React.createElement(ProfileNewslettersIndex, {
      user: new User(options.user),
      currentRegion: new Region(options.currentRegion),
    })
    const root = createRoot(domContainer)
    root.render(container)
  }
}

export default ProfileNewslettersPage
